module.exports = __webpack_public_path__ + "static/media/end-to-end.96076202.jpg";